import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminRoutingModule } from './admin-routing.module';
import { RepresentativesComponent } from './representatives/representatives.component';
import { SharedModule } from '@app/@shared';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ReactiveFormsModule } from '@angular/forms';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { RepresentativeTableComponent } from './representatives/components/representative-table/representative-table.component';
import { NewRepresentativeComponent } from './representatives/components/new-representative/new-representative.component';
import { RepresentativeDetailComponent } from './representatives/components/representative-detail/representative-detail.component';
import { RepresentativeMerchantsCardComponent } from './representatives/components/representative-merchants-card/representative-merchants-card.component';
import { RepresentativeFormComponent } from './representatives/forms/representative-form/representative-form.component';
import { RepresentativesApiService } from './representatives/services/representatives.api.service';
import { RepresentativeFormService } from './representatives/services/representative-form.service';

@NgModule({
  declarations: [RepresentativesComponent],
  imports: [
    CommonModule,
    AdminRoutingModule,
    SharedModule,
    TableModule,
    ButtonModule,
    ReactiveFormsModule,
    CardModule,
    InputTextModule,
    DropdownModule,
    RepresentativeTableComponent,
    NewRepresentativeComponent,
    RepresentativeDetailComponent,
    RepresentativeMerchantsCardComponent,
    RepresentativeFormComponent,
  ],
  providers: [RepresentativesApiService, RepresentativeFormService],
})
export class AdminModule {}
